/**************************************************
 * Nombre:       Producto_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import fondo from '../../Recursos/fondo_producto.png'
import Tarjeta_Producto_Detalle from "./Tarjeta_Producto_Detalle";
import {useContext, useEffect, useRef, useState} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {contexApp} from "../../App";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {theme} from "../../Tema";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";

const Producto_Home = () => {
    const {sCell, masSM} = useResponsive()
    const cData = useContext(contexApp)
    const refe = useRef()
    const [productos, setProductos] = useState({})

    const siguiente = () => {
        refe.current.go('>')
    }

    const atras = () => {
        refe.current.go('<')
    }


    useEffect(() => {

        setProductos(cData.productosHome)
        console.log(cData.productosHome)

    }, [cData])
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            size={12}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                size={12}
                sx={{maxWidth: '1400px', px: 3, pb: sCell ? 24 : 4}}
            >

                {productos && productos.length > 0 &&
                    <Grid item container size={{xs: 12, sm: 12, md: 10}}
                          sx={{justifyContent: 'flex-start', marginTop: masSM ? 8 : 3}}>
                        <Splide
                            ref={refe}
                            aria-label="My Favorite" style={{width: '100%'}}
                            options={{
                                autoplay: true,
                                speed: 3000,
                                rewind: true,
                                perPage: 1,
                                arrows: sCell,
                                gap: 0,
                                interval: 8000,
                                pagination: false,
                                width: '100%',
                                drag: false,
                                type: 'fade'


                            }}
                        >
                            {productos.map((item, index) => {
                                return (
                                    <SplideSlide key={`wrdf${index}`}>
                                        <Tarjeta_Producto_Detalle item={item}/>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>
                    </Grid>
                }

                {!sCell &&
                    <Grid
                        container
                        justifyContent={'flex-end'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 10}}
                        sx={{mt: -26}}
                        spacing={2}
                    >

                        <IconButton
                            onClick={() => atras()}
                            sx={{
                                backgroundColor: theme.palette.secondary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.secondary.main + 80
                                }
                            }}>
                            <KeyboardArrowLeft sx={{fill: '#fff'}}/>
                        </IconButton>

                        <IconButton
                            onClick={() => siguiente()}
                            sx={{
                                backgroundColor: theme.palette.secondary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.secondary.main + 80
                                }
                            }}>
                            <KeyboardArrowRight sx={{fill: '#fff'}}/>
                        </IconButton>

                    </Grid>
                }


            </Grid>

        </Grid>
    )

}
export default Producto_Home